import Glide from '@glidejs/glide'

export default function heroSlider (){

  // VIDEO SLIDER
  const slider = document.querySelector('.glideHero')
  let hero = new Glide(slider,{
    autoplay: 4000,
    hoverpause: false,
    gap: 0,
    keyboard: false
  })

  hero.mount()
}
